import { ColorAlternative } from '@coolblue-development/next-patterns/client';
import { type Product, Value } from '@features/product/components/Collection/Collection.types';
import { AvailabilityState } from '@features/product/typings';

import { getCollectionProductImageId } from './getCollectionProductImageId';

export const getColorAlternatives = (
  values: Value[],
  popoverStrings: Record<string, string>
): ColorAlternative[] => {
  const colorAlternatives: ColorAlternative[] = [];

  values.forEach(value => {
    const { product } = value;

    if (product) {
      const popoverString = getPopoverText(product);

      colorAlternatives.push({
        color: value.name,
        productId: product.id ?? '',
        imageId: getCollectionProductImageId(product),
        popover: popoverStrings[popoverString] ? popoverStrings[popoverString] : '',
        isDisabled: !product.shouldRedirect
      });
    }
  });

  return colorAlternatives;
};

export const getPopoverText = (product: Product | null) => {
  switch (product?.nullableAvailabilityState) {
    case undefined:
    case AvailabilityState.OutOfStock:
      return 'notAvailableInVariant';
    case AvailabilityState.TemporaryOutOfStock:
      return 'temporaryOutOfStock';
    default:
      return '';
  }
};
